// preventRenderingInClientIfNot :: Boolean -> Boolean
export const preventRenderingInClientIfNot = isTrue => ENV.SERVER || isTrue;



/** WEBPACK FOOTER **
 ** ./app/wip_modules/prevent-rendering-if-not/index.js
 **/